export enum ProductCardType {
    CREDIT = 1,
    DEBIT = 2,
}
